import { Box, Typography } from '@mui/material';
import localStrings from "../localStrings";

export const NoData = () => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      overflow: 'hidden'
    }}
  >
    <Box
      component="img"
      src="/assets/errors/error-404.png"
      sx={{
        height: 'auto',
        maxWidth: 200
      }}
    />
    <Typography
      color="text.secondary"
      sx={{ mt: 2 }}
      variant="subtitle1"
    >
        {localStrings.noData}
    </Typography>
  </Box>
);
